import Layout from '@ep/components/Layout';
import SEO from '@ep/components/Seo';
import CTAModule, { CTAModuleProps } from '@ep/modules/CTAModule';
import HeroTextModule from '@ep/modules/HeroTextModule';
import IncentiveEstimatorModuleCAN from '@ep/modules/IncentiveEstimatorModuleCAN';
import IncentiveEstimatorModuleUS from '@ep/modules/IncentiveEstimatorModuleUS';
import SectionMenu, { SectionMenuProps } from '@ep/modules/SectionMenuModule';
import { Gcms_IncentiveEstimatorPage } from '@ep/types/gatsbyTypes';
import getModuleProps from '@ep/utils/getModuleProps';
import getSeoProps from '@ep/utils/getSeoProps';
import { WindowLocation } from '@reach/router';
import { graphql } from 'gatsby';
import React from 'react';

export interface IncentiveEstimatorPageProps {
  location: WindowLocation;
  data: {
    gcms: {
      incentiveEstimatorPage: Gcms_IncentiveEstimatorPage;
    };
  };
}

function IncentiveEstimatorPage({ data }: IncentiveEstimatorPageProps) {
  const currentUrl =
    typeof window !== 'undefined' ? window.location.pathname : '';
  const page = data.gcms.incentiveEstimatorPage;
  const hasSectionMenu = Boolean(
    page.subMenu ? page.subMenu.length > 0 : false,
  );
  const hasCTASection = Boolean(page.ctaHeading && page.ctaSubheading);
  return (
    <Layout pathname={currentUrl} subMenu={page.subMenu}>
      <SEO {...getSeoProps(page)} />
      {hasSectionMenu && (
        <SectionMenu
          pathname={currentUrl}
          {...(getModuleProps(page, 'sub') as SectionMenuProps)}
        />
      )}
      <HeroTextModule
        {...(getModuleProps(page, 'hero') as HeroTextModuleProps)}
      />
      {currentUrl.includes('us') && (
        <>
          <IncentiveEstimatorModuleUS />
          {hasCTASection && (
            <CTAModule {...(getModuleProps(page, 'cta') as CTAModuleProps)} />
          )}
        </>
      )}
      {currentUrl.includes('canada') && (
        <>
          <IncentiveEstimatorModuleCAN />
          {hasCTASection && (
            <CTAModule {...(getModuleProps(page, 'cta') as CTAModuleProps)} />
          )}
        </>
      )}
    </Layout>
  );
}

export const query = graphql`
  query IncentiveEstimatorPageQuery($id: ID!) {
    gcms {
      incentiveEstimatorPage(where: { id: $id }) {
        title
        metaTitle
        description
        metaDescription
        structuredData
        slug
        subMenu {
          data
        }
        heroHeading
        heroBackground {
          url
          altText
          vidyardLink
        }
        ctaHeading
        ctaHeadingColor {
          hex
        }
        ctaSubheadingColor {
          hex
        }
        ctaSubheading {
          html
        }
        ctaSecondarySubheadingColor {
          hex
        }
        ctaButtonLabel
        ctaButtonLink
        ctaBackground {
          url
          altText
        }
        ctaSecondarySubheading {
          html
        }
      }
    }
  }
`;

export default IncentiveEstimatorPage;
